import { render } from "./ComplianceCheckingForRequested.vue?vue&type=template&id=e52f3b9a"
import script from "./ComplianceCheckingForRequested.vue?vue&type=script&lang=js"
export * from "./ComplianceCheckingForRequested.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__